module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='\n<form>\n\n\n    <div class="tab-contents js-tabs-container">\n\n        <!-- Basic Section -->\n        <div class="m-modal-section" >\n          <div class="m-modal-subsection" >\n\n            <div class="m-modal-column">\n              <div class="form-group">\n                  <input type="checkbox" name="enabled"  ';
 if (_.get(obj, 'enabled')) { 
__p+='checked="checked"';
 } 
__p+='/>\n                  <label for="" class="">Enabled</label>\n              </div>\n              <div class="form-group">\n                  <label for="name">Name</label>\n                  <input type="input" class="form-control" name="name" placeholder="" value="'+
((__t=( obj.name ))==null?'':__t)+
'">\n              </div>\n\n              ';
 if (userHasRole('super')) { 
__p+='\n              <div class="form-group">\n                  <label for="name">Role</label>\n\n                  <select class="form-control js-selected-role-type" name="role">\n                      <option value="">Choose...</option>\n\n                      ';
 _.each(getApiRoles(), function(value, key){ 
__p+='\n                      ';
 if (obj._id) { 
__p+='\n                      <option value="'+
((__t=( key ))==null?'':__t)+
'" '+
((__t=( key === role ? 'selected' : void 0  ))==null?'':__t)+
'  >'+
((__t=( value.name ))==null?'':__t)+
'</option>\n                      ';
 } else { 
__p+='\n                      <option value="'+
((__t=( key ))==null?'':__t)+
'" >'+
((__t=( value.name ))==null?'':__t)+
'</option>\n                      ';
 } 
__p+='\n\n                      ';
 }); 
__p+='\n                  </select>\n              </div>\n              ';
 } 
__p+='\n            </div>\n          </div>\n        </div>\n\n        <!-- Notifications Section -->\n        ';
 if (_.get(obj, 'key')) { 
__p+='\n        <div class="m-modal-section m-tab" id="tab-notifications">\n\n            <div class="m-modal-subsection" >\n                <div class="m-modal-subsection__title">Key</div>\n                <div class="m-modal-row">\n                  <div class="fullkey">\n                  '+
((__t=( obj.key ))==null?'':__t)+
'\n                </span>\n                </div>\n            </div>\n\n        </div>\n        ';
 } 
__p+='\n\n    </div>\n</form>\n';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./js/modules/client-apikeys/edit_new/templates/body.html
// module id = 417
// module chunks = 0